export const useScreenRecording = () => {
    const detectMimeType = () => {
        const mimeTypes = [
            'video/webm;codecs=vp9,opus',
            'video/webm;codecs=vp8,opus',
            'video/webm',
        ];

        for (let mimeType of mimeTypes) {
            if (MediaRecorder.isTypeSupported(mimeType)) {
                return mimeType;
            }
        }

        return '';
    };
    const stopMediaStream = async (stream) => {
        stream.getTracks().forEach((track) => track.stop());
    };

    const combineBlobs = (recordedBlobs) => {
        return new Blob(recordedBlobs, { type: 'video/webm' });
    };

    const onFinished = async (recordedBlobs, onFinish) => {
        const blob = combineBlobs(recordedBlobs);
        onFinish?.(blob)
    }

    return async (onFinish) => {
        const stream = await navigator.mediaDevices.getDisplayMedia(
            {
                video: true,
                audio: false,
                preferCurrentTab: true,
                selfBrowserSurface: "include",
                surfaceSwitching: "exclude"
            }
        );
        const options = { mimeType: detectMimeType() };
        const mediaRecorder = new MediaRecorder(stream, options);
        const recordedBlobs = [];
        mediaRecorder.ondataavailable = (event) => {
            if (event.data && event.data.size > 0) {
                recordedBlobs.push(event.data);
            }
        };
        mediaRecorder.onstop = () => {
            onFinished(recordedBlobs, onFinish);
            stopMediaStream(stream);
        };
        mediaRecorder.start();
    }
}